import React, { ElementType, FC } from 'react';
import { Outlet } from 'react-router-dom';

import { TabEntry } from './PageTabs';

interface CustomPageProps {
  entries?: TabEntry[];
  element: ElementType;
}

export type CustomPageContext = { entries?: TabEntry[] };

export const Page: FC<CustomPageProps> = ({ element, entries }) => {
  return (
    <div className="mx-auto w-full grow flex flex-col">{React.createElement(element, { entries }, <Outlet />)}</div>
  );
};
